/**
 * nts-hl-config.js — v3
 * Store constants, rules config, component instantiation, wiring.
 * LAST to load: bus -> cache -> rules -> cart -> drawer -> config
 *
 * Ship-Insure variant: 47002137985270 ($4.84)
 * Variant IDs confirmed from live Storefront API (2026-05-25)
 */
(function() {
  var bus = window.NTS.bus;

  /* ── Store ── */
  // NT SKIN (Meta Ads front-end): the cart is built on the MAIN store's
  // Storefront API (cross-origin, open/tokenless) and checks out on main. The
  // products + GWP all live on main; skin is just the skin.
  var STORE = {
    domain:   'https://naked-thriving-skincare.myshopify.com',
    currency: 'USD',
  };

  /* ── Ship-Insure (main store variant) ── */
  var SHIP_INSURE = {
    variantId:  47002137985270,
    price:      484,
    attributes: [{ key: '_si', value: 'true' }],
  };

  /* ── Coupons (Layer 1) — built from coupons.json (single source of truth,
     also baked into the coupon-travel Shopify Function at deploy). The inline
     DEFAULT_COUPONS below is a fallback so the cart still works if the file
     fails to load; the fetched JSON overrides it (see bottom of file). ────── */
  var SI_VARIANT_ID = SHIP_INSURE.variantId;

  // Build an eligibility predicate for one coupon from its JSON `eligibility`
  // block. Mirrors the server Function's isQualifyingLine so the two layers
  // agree on which carts get the gift.
  function makeQualify(elig, giftVariantId) {
    elig = elig || {};
    var types = (elig.excludeProductTypes || []).map(function(t){ return String(t).toUpperCase(); });
    var frags = elig.excludeHandleFragments || [];
    var requireHandles = (elig.requireHandles || []).map(function(h){ return String(h).toLowerCase(); });
    var miniWord = /\bmini\b/i;
    var gcWord = /\bgift\s*card\b/i;
    return function(item) {
      var vid = item.variantId != null
        ? Number(item.variantId)
        : Number(String(item.merchandiseId || '').split('/').pop());
      if (vid === giftVariantId || vid === SI_VARIANT_ID) return false;
      var type   = (item.product_type || item.productType || '').toUpperCase();
      var handle = (item.handle || '').toLowerCase();
      var title  = item.product_title || item.title || '';
      if (types.indexOf(type) !== -1) return false;
      for (var i = 0; i < frags.length; i++) {
        if (handle.indexOf(frags[i]) !== -1) return false;
      }
      if (elig.excludeMini && (miniWord.test(title) || miniWord.test(handle))) return false;
      if (elig.excludeGiftCardTitle && gcWord.test(title)) return false;
      // Allow-list: when set, only these product handles qualify.
      if (requireHandles.length && requireHandles.indexOf(handle) === -1) return false;
      return true;
    };
  }

  // Map the JSON coupons array → the BUNDLES scenario object the matcher uses.
  function buildBundlesFromCoupons(coupons) {
    var out = {};
    (coupons || []).forEach(function(c) {
      if (!c || !c.code) return;
      var giftId = c.gift && c.gift.variantId;
      out[c.key || c.code] = {
        label: c.label || c.code,
        discountCode: c.code,
        matchAll: c.matchAll !== false,
        qualify: makeQualify(c.eligibility, giftId),
        excludeVariantIds: [SI_VARIANT_ID].concat(giftId ? [giftId] : []),
        items: c.items || [],
        freeGift: c.gift ? {
          variantId: c.gift.variantId,
          title: c.gift.title,
          variantTitle: c.gift.variantTitle || null,
          price: c.gift.price,
          image: c.gift.image,
        } : null,
      };
    });
    return out;
  }

  // Inline fallback — same data as assets/coupons.json. Keep in sync (or rely
  // on the fetch below to override). This guarantees the cart works offline.
  var DEFAULT_COUPONS = [{
    key: 'travelGift',
    label: 'Any qualifying product → free Travel-Size (10mL)',
    code: 'TRAVEL',
    matchAll: true,
    gift: {
      variantId: 44455419642102,
      title: 'Illuminate BC+ Brightening Serum',
      variantTitle: 'Travel-Size (10mL)',
      price: 3200,
      image: 'https://cdn.shopify.com/s/files/1/0663/8908/2358/files/PDP-Illuminate-APR2025-07.webp?v=1770998436&width=220',
    },
    eligibility: {
      excludeProductTypes: ['SKIN CARE TOOLS','TOOL','TOOLS','ACCESSORY','ACCESSORIES','GIFT CARD','GIFT CARDS','SHIP-INSURE','INSURANCE','SHOPWILL','MINI SET','MINI SETS'],
      excludeHandleFragments: ['ship-insure','shipinsure','shipping-insurance','shipping-protection','gift-card'],
      excludeMini: true,
      excludeGiftCardTitle: true,
    },
  }];

  var BUNDLES = buildBundlesFromCoupons(DEFAULT_COUPONS);

  /* ── Rules ── */
  var RULES = {
    // 'merge': re-adding a product already in the cart stacks quantity (server
    // cartLinesAdd merges the line) instead of being skipped. quantityCap still
    // bounds it; SI/gift never duplicate (their own rules guard + cap at 1).
    dedupe: { enabled: true, mode: 'merge' },
    shipInsure: {
      enabled:    true,
      variantId:  SHIP_INSURE.variantId,
      price:      SHIP_INSURE.price,
      attributes: SHIP_INSURE.attributes,
      condition:  'always',
    },
    freeGift: {
      enabled: false,  // disabled globally — each bundle manages its own gift
    },
    quantityCap: {
      enabled:    true,
      defaultMax: 5,
      overrides: {},
    },
  };
  // Cap SI at 1
  RULES.quantityCap.overrides[SHIP_INSURE.variantId] = 1;
  // Cap every coupon's free gift at 1 — one per cart, no matter how many adds.
  function capGifts(bundles) {
    Object.keys(bundles).forEach(function(k) {
      var g = bundles[k].freeGift;
      if (g && g.variantId) RULES.quantityCap.overrides[g.variantId] = 1;
    });
  }
  capGifts(BUNDLES);
  // Respect a previous Ship-Insure opt-out (drawer checkbox persists it)
  try {
    if (localStorage.getItem('nts_si_optout') === '1') RULES.shipInsure.enabled = false;
  } catch (e) {}

  /* ── Config ── */
  var config = {
    store:           STORE,
    bundle:          [],  // no default bundle (TRAVEL gift is injected per-ATC by the matcher)
    bundles:         BUNDLES,
    rules:           RULES,
    shipInsure:      SHIP_INSURE,
    discountCodes:   [],
    cartAttributes:  [],
    // Codes the shopper removed from the pill this session — the auto-matcher
    // skips these so a removed coupon never re-applies on the next add. In-memory
    // (resets on reload, so a fresh ?token= funnel entry re-enables it).
    optedOutCodes:   new Set(),
    drawer: { autoOpen: { onAdd: true, onBundle: true, onUpsell: false } },
  };

  /* ── Components ── */

  var cache = new CartManager({ bus: bus, storageKey: 'nts_hl_cart_v3' });

  var engine = new CartRulesEngine();
  engine.use(createDedupeRule(RULES.dedupe));
  engine.use(createShipInsureRule(RULES.shipInsure));
  engine.use(createQuantityCapRule(RULES.quantityCap));

  var cart = new CartFacade({ bus: bus, cache: cache, rules: engine, config: config });

  var drawerEl = document.getElementById('nts-hl-drawer');
  var drawer = new CartDrawer({ bus: bus, cache: cache, cart: cart, el: drawerEl, config: config });

  /* ── Expose ── */
  window.NTS.cart    = cart;
  window.NTS.drawer  = drawer;
  window.NTS.cache   = cache;
  window.NTS.config  = config;
  window.NTS.BUNDLES = BUNDLES;

  /**
   * addScenario(key) — add a coupon scenario bundle.
   * Builds GQL lines from the scenario config, includes free gift if defined,
   * sets discount code on cart creation.
   */
  window.NTS.addScenario = async function(key) {
    var scenario = BUNDLES[key];
    if (!scenario) { console.error('Unknown scenario:', key); return; }

    // Build GQL line items
    var lines = scenario.items.map(function(i) {
      return { merchandiseId: 'gid://shopify/ProductVariant/' + i.variantId, quantity: 1 };
    });

    // Add free gift if defined
    if (scenario.freeGift) {
      lines.push({
        merchandiseId: 'gid://shopify/ProductVariant/' + scenario.freeGift.variantId,
        quantity: 1,
      });
    }

    // Set discount code for this scenario
    config.discountCodes = scenario.discountCode ? [scenario.discountCode] : [];

    // Add via facade (rules will inject SI, dedupe, cap)
    var result = await cart.add(lines, 'bundle');
    return result;
  };

  /* ── URL token → auto-coupon gate (DO-3073 Meta Ads funnel) ──
     ?token=BE374 turns on the TRAVEL coupon: it then auto-applies to ANY
     qualifying product added to the cart, and ALL other (per-product) coupons
     are ignored. WITHOUT the token, nothing is auto-applied (manual coupon
     entry in the drawer still works). The token persists for the session once
     seen, so the coupon survives navigation within the funnel.
     config.tokenCode is the gate the auto-matcher (nts-hl-cart _matchScenarios)
     checks: only the coupon whose code === tokenCode auto-fires.

     URL-ONLY: the token must be in THIS page's URL to activate. We do NOT
     persist or restore it from localStorage. Persisting meant a visitor who
     once arrived with the token kept getting the coupon + free gift on later
     token-less visits — the code would apply then drop off, leaving the gift at
     full price. No token in the current URL => no auto-coupon and no free gift
     (manual coupon entry in the drawer still works). */
  var TOKEN_MAP = { 'BE374': 'TRAVEL' };
  var urlToken = (new URLSearchParams(window.location.search).get('token') || '').trim().toUpperCase();
  var tokenCode = TOKEN_MAP[urlToken] || null;
  // Purge any token persisted by an older build so it can't keep activating.
  try { localStorage.removeItem('nt_travel_token'); } catch (e) {}
  config.tokenCode = tokenCode;                       // gate for the auto-matcher
  config.discountCodes = tokenCode ? [tokenCode] : []; // applied on cart create

  /* ── Hydrate ── */
  var cached = cache.getCart();
  if (cached.shopifyCartId) {
    // If a cart already exists, sync server state first. If the URL also
    // brought a token, ensure the matching code is on the cart afterwards
    // (sync may overwrite the local cache with whatever codes the server has).
    cart.sync().then(function() {
      if (!tokenCode) return;
      var currentCodes = (cache.getCart().discountCodes || []).map(function(d) { return d.code; });
      if (currentCodes.indexOf(tokenCode) === -1) {
        cart.applyDiscount(currentCodes.concat([tokenCode]));
      }
    }).catch(function() {});
  }

  /* ── Coupons source of truth: fetch coupons.json and override the inline
     fallback. Same file is baked into the coupon-travel Function at deploy, so
     theme + function stay in sync from ONE file. Safe: on any failure the
     inline DEFAULT_COUPONS bundles remain in effect. ─────────────────────── */
  if (window.NT_COUPONS_URL) {
    fetch(window.NT_COUPONS_URL)
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(d) {
        var coupons = d && d.coupons;
        if (!coupons || !coupons.length) return;
        var built = buildBundlesFromCoupons(coupons);
        config.bundles = built;
        window.NTS.BUNDLES = built;
        capGifts(built);
      })
      .catch(function() { /* keep inline fallback */ });
  }

  /* ── Debug ── */
  if (window.location.search.indexOf('nts-debug') !== -1) {
    bus.on('*', function(e) {
      console.log('%c[NTS v3]', 'color:#627059;font-weight:bold', e.event, e);
    });
  }
})();
